/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermitDisplayComponent } from "cms/components/permit-display";

const YourPermits = () => {

    //TODO: SC-1850 - Get permit component data from CMS instead of using mock data
    const mockComponentData = {
        show_summary: true,
        show_filter: true,
        type: "housing",
    };

    // TODO: This is just for testing. PermitDisplayComponent is a SimpliCity Component
    //       SimpliCity Components are not used directly like regular react components

    return (
        <main>
            <PermitDisplayComponent
                component={mockComponentData}
                // permits={permits}
                // onChangeHandler={permitSearchOnChange}
                // onSearchHandler={searchPermitHandler}
                // searchText={searchText}
                // SearchFilterComp={YourSearch}
            />
        </main>
    );
};

export { YourPermits };
